import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Login from './pages/Login';
import Signup from './pages/Signup';
import Feed from './pages/Feed';
import Chat from './pages/Chat';
import CreatePost from './pages/CreatePost';
import Profile from './pages/Profile';
import Explore from './pages/Explore';

import Brand from './brand/pages/Brand';
import BrandSettings from './brand/pages/BrandSettings';

import { AuthProvider, useAuth } from './contexts/AuthContext';
import { BrandProvider } from './brand/context/BrandContext';

function PrivateRoute({ children }) {

    const { user } = useAuth();

    return user
        ? children
        : <Navigate to="/login" />;

}

export default function App() {

    return (

        <AuthProvider>

            <BrandProvider>

                <Router>

                    <Routes>

                        <Route
                            path="/"
                            element={<Feed />}
                        />

                        <Route
                            path="/login"
                            element={<Login />}
                        />

                        <Route
                            path="/signup"
                            element={<Signup />}
                        />

                        <Route
                            path="/chat/:id"
                            element={<Chat />}
                        />

                        <Route
                            path="/create"
                            element={
                                <PrivateRoute>
                                    <CreatePost />
                                </PrivateRoute>
                            }
                        />

                        <Route
                            path="/profile/:id"
                            element={
                                <PrivateRoute>
                                    <Profile />
                                </PrivateRoute>
                            }
                        />

                        <Route
                            path="/explore"
                            element={
                                <PrivateRoute>
                                    <Explore />
                                </PrivateRoute>
                            }
                        />

                        <Route
                            path="/brand/*"
                            element={
                                <PrivateRoute>
                                    <Brand />
                                </PrivateRoute>
                            }
                        />

                        <Route
                            path="/brand/settings"
                            element={
                                <PrivateRoute>
                                    <BrandSettings />
                                </PrivateRoute>
                            }
                        />

                    </Routes>

                </Router>

            </BrandProvider>

        </AuthProvider>

    );

}